import success from '@/assets/images/icon_success.png'


const Toast = (text: number | string, icon?: string | any, time = 1.5, centerInPdfArea = false) => {
    if (!text) {
        return
    }
    let toastTimeout: ReturnType<typeof setTimeout> | null = null; // 用于存储定时器的引用
    // 销毁定时器
    if (toastTimeout) {
        clearTimeout(toastTimeout);
    }

    // 检查是否存在现有的提示框（含桌面/移动端），如果存在则移除
    const existingDesktop = document.querySelector('.desktop-success_toast');
    const existingMobile = document.querySelector('.mobile-success_toast');
    if (existingDesktop) existingDesktop.remove();
    if (existingMobile) existingMobile.remove();

    // 创建容器
    const div: HTMLDivElement = document.createElement('div')
    div.className = window.innerWidth > 768 ? "desktop-success_toast" : "mobile-success_toast"
    // ✅ 添加基本样式确保元素可见
    div.style.position = 'fixed'

    // ✅ 如果指定了 centerInPdfArea，则定位到 PDF 区域中间，否则定位到浏览器中间
    if (centerInPdfArea) {
        const pdfArea = document.querySelector('.editor-content-area') as HTMLElement
        if (pdfArea) {
            const rect = pdfArea.getBoundingClientRect()
            const centerX = rect.left + rect.width / 2
            const centerY = rect.top + rect.height / 2
            div.style.left = `${centerX}px`
            div.style.top = `${centerY}px`
            div.style.transform = 'translate(-50%, -50%)'
        } else {
            // 如果找不到 PDF 区域，回退到浏览器居中
            div.style.top = '45%'
            div.style.left = '50%'
            div.style.transform = 'translate(-50%, -50%)'
        }
    } else {
        // 默认浏览器居中
        div.style.top = '45%'
        div.style.left = '50%'
        div.style.transform = 'translate(-50%, -50%)'
    }

    div.style.zIndex = '10001'
    div.style.backgroundColor = 'rgba(0, 0, 0, 0.7)'
    div.style.borderRadius = '4px'
    // 创建二级容器
    const toastContainer: HTMLDivElement = document.createElement('div')
    toastContainer.className = window.innerWidth > 768 ? "desktop-success_toast_container" : "mobile-success_toast_container"
    // 创建img
    // 创建i标签用于loading动画
    if (icon === 'loading') {
        const i = document.createElement('i')
        i.className = 'iconfont loading icon-icon_loading'
        i.style.color = 'white'
        toastContainer.appendChild(i)
    } else if (icon) {
        if (icon === 'success') {
            icon = success
            const img = document.createElement('img')
            img.src = icon
            img.className = window.innerWidth > 768 ? 'desktop-success_toast_icon' : 'mobile-success_toast_icon'
            toastContainer.appendChild(img)
        } else if (icon === 'fail') {
            const i = document.createElement('i')
            i.className = 'iconfont icon-icon_cancel'
            i.style.color = 'white'
            toastContainer.appendChild(i)
        }

    }
    //创建文本span
    const span = document.createElement('div')
    span.className = 'toast_text'
    span.innerHTML = text as string
    toastContainer.appendChild(span)
    div.appendChild(toastContainer)
    document.body.appendChild(div)
    // loading 且 time 为 0 时不自动关闭，需外部调用 Toast.clear() 关闭
    if (!(icon === 'loading' && time === 0)) {
        toastTimeout = setTimeout(() => {
            div.remove()
        }, time * 1500)
    }
}

/** 关闭当前正在显示的 Toast（如 loading），不影响其他逻辑 */
Toast.clear = () => {
    const existingDesktop = document.querySelector('.desktop-success_toast');
    const existingMobile = document.querySelector('.mobile-success_toast');
    if (existingDesktop) existingDesktop.remove();
    if (existingMobile) existingMobile.remove();
}

export default Toast
